export default "__VITE_ASSET__CjeEFeL___"